import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginAdmin } from '../../services/apiService';

// Async thunk for admin login
export const loginAdminAsync = createAsyncThunk(
  'auth/loginAdmin',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await loginAdmin(credentials);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'خطا در ورود');
    }
  }
);

const initialState = {
  currentUser: null,
  isLogin: false,
  loading: false,
  error: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.currentUser = null;
      state.isLogin = false;
      state.token = null;
      state.error = null;
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_token_exp');
    },
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.currentUser = action.payload;
      state.isLogin = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdminAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdminAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.isLogin = true;
        state.currentUser = action.payload.user || action.payload;
        state.token = action.payload.token || action.payload.accessToken;
        state.error = null;
        
        // Store token in localStorage
        if (state.token) {
          localStorage.setItem('admin_token', state.token);
          const expirationTime = new Date().getTime() + (24 * 60 * 60 * 1000); // 24 hours
          localStorage.setItem('admin_token_exp', expirationTime.toString());
        }
      })
      .addCase(loginAdminAsync.rejected, (state, action) => {
        state.loading = false;
        state.isLogin = false;
        state.currentUser = null;
        state.token = null;
        state.error = action.payload;
      });
  },
});

export const { logout, clearError, setUser } = authSlice.actions;
export default authSlice.reducer;
